import { InjectionToken } from '@angular/core';

import { injectMailgunBlockDepth, provideMailgunBlockDepth } from '../mailgun/tokens';
import {
  PostRenderCleanupService,
  PostRenderCleanupServiceToken,
} from '../services/post-render-cleanup.service';
import type { EmailTemplateRoute } from '../types';

export interface TemplateRendererConfigI {
  interpolate: boolean;
  templateRoutes?: EmailTemplateRoute[];
  scope?: number;
}

export const provideTemplateRenderer = (opts: TemplateRendererConfigI) => [
  provideMailgunBlockDepth(),
  {
    provide: TemplateRendererConfig,
    useFactory: () => ({
      ...opts,
      scope: injectMailgunBlockDepth(),
    }),
  },
  {
    provide: PostRenderCleanupServiceToken,
    useClass: PostRenderCleanupService,
  },
];

export const TemplateRendererConfig = new InjectionToken<TemplateRendererConfigI>('AppConfig');
